import React from 'react'
import styled from 'styled-components'
import Sticky from 'react-stickynode'
import { Box, Container } from 'pcln-design-system'

const StickyNode = styled(Sticky)`
  > div {
    left: 0;
  }
`
const StickyEffectContainer = styled(Container)`
  padding: 16px 16px 0px;
`

type StickyEffectProps = {
  enabled: boolean
  isStickyInEffect: boolean
  children?: React.ReactNode
  handleStickyEffectStateChange?: (state: Sticky.Status) => void
  stickyHeight?: number
}

export default function StickyEffect({
  children,
  handleStickyEffectStateChange,
  enabled,
  isStickyInEffect,
  stickyHeight = 80
}: StickyEffectProps) {
  return (
    <StickyNode
      enabled={enabled}
      innerZ={1}
      onStateChange={handleStickyEffectStateChange}
      enableTransforms={false}
    >
      {isStickyInEffect ? (
        <Box width="100vw" pb={1} color="text.dark">
          <StickyEffectContainer maxWidth={1280} stickyHeight={stickyHeight}>
            {children}
          </StickyEffectContainer>
        </Box>
      ) : (
        children
      )}
    </StickyNode>
  )
}
